module.exports = __webpack_public_path__ + "static/media/Emer.3f31b0f4.png";